import { Spinner } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { UnsubscribePageContainer } from '..';

/**
 * Component to display a pending screen when the unsubscribe data is being updated
 * @returns A component to display a pending screen when the unsubscribe data is being updated
 */
function UnsubscribeScreenPending() {
  const t = useTranslations('unsubscribe');
  return (
    <UnsubscribePageContainer>
      <UnsubscribePageContainer.NotificationContainer>
        <Spinner size="medium" className="mx-auto animate-spin text-accent-green" aria-hidden="true" />
        <p className="text-center text-foreground-subtle">{t('updating_preferences')}</p>
      </UnsubscribePageContainer.NotificationContainer>
    </UnsubscribePageContainer>
  );
}

export { UnsubscribeScreenPending };
